import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// Importa el componente 'motion' de framer-motion
import { motion } from 'framer-motion'; 
import img2 from '../assets/imagen_2.png'; 
import Carousel from '../components/Carousel';

// === 1. LÓGICA Y CONSTANTES DE DISEÑO ===
const WA_PHONE = '+51983318651';
const WHATSAPP_MESSAGE = 'Hola, quiero información de Tesis 1 Consultoria';
const whatsappUrl = `https://wa.me/${WA_PHONE}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

// === 2. ICONOS SVG (Sin cambios) ===
const Icon = {
  Check: (props) => (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ),
  Arrow: (props) => (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M7 17l9.2-9.2M17 17V7H7" />
    </svg>
  ),
  Doc: (props) => (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
      <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
    </svg>
  ),
  Stats: (props) => (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M18 20V10M12 20V4M6 20v-6" />
    </svg>
  ),
  Quote: (props) => (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3 21c3.333-4 5-6 5-8V5a2 2 0 012-2h8a2 2 0 012 2v8c0 2-1.667 4-5 8" />
    </svg>
  ),
  Whatsapp: (props) => (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.263c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884"/>
    </svg>
  ),
  Sparkles: (props) => (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12 3l1.545 4.635L18.18 9.18l-4.635 1.545L12 15.36l-1.545-4.635L5.82 9.18l4.635-1.545L12 3z"/>
      <path d="M6 3l.545 1.635L8.18 5.18l-1.635.545L6 7.36 5.455 5.725 3.82 5.18l1.635-.545L6 3z"/>
      <path d="M18 14l.545 1.635L20.18 16.18l-1.635.545L18 18.36l-.545-1.635-1.635-.545 1.635-.545L18 14z"/>
    </svg>
  )
};

const getServiceIcon = (name) => {
  const n = name.toLowerCase();
  if (n.includes('artículo') || n.includes('observaciones') || n.includes('monografia') || n.includes('ensayo')) return <Icon.Doc />;
  if (n.includes('parafraseo')) return <Icon.Quote />;
  if (n.includes('planes') || n.includes('negocio') || n.includes('diapositivas') || n.includes('inteligencia')) return <Icon.Stats />;
  return <Icon.Doc />;
};

// === 3. Componente SectionTitle (Ahora con Motion) ===
function SectionTitle({ kicker, title, subtitle, className = "" }) {
  // Las variantes definen los estados de la animación
  const variants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    // Usa motion.div como contenedor para la animación
    <motion.div 
      className={`text-center max-w-4xl mx-auto ${className}`}
      initial="hidden" // Estado inicial
      whileInView="visible" // Estado cuando está en la vista
      viewport={{ once: true, amount: 0.2 }} // Solo se anima una vez cuando el 20% es visible
      variants={variants}
    >
      {kicker && (
        <div className="inline-flex items-center gap-2 px-4 py-2 text-xs font-bold tracking-widest uppercase rounded-full bg-gradient-to-r from-yellow-50 to-yellow-100 text-amber-700 border border-amber-300 shadow-md">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-600 animate-pulse"></span>
          {kicker}
        </div>
      )}
      <h2 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-gray-900 leading-[1.15]">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-6 text-lg sm:text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto font-light">
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}

// === 4. Componente Principal Home ===
export default function Home({ services = [] }) {
  const [scrollY, setScrollY] = useState(0);
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Efecto Parallax optimizado (sin cambios)
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Manejador de formulario (sin cambios)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await new Promise(resolve => setTimeout(resolve, 1500));
    alert('¡Gracias! Te contactaremos pronto.');
    setFormData({ name: '', email: '', message: '' });
    setIsSubmitting(false);
  };

  // Variantes para la animación secuencial de las tarjetas de servicio
  const serviceCardVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.95 },
    visible: i => ({ 
      opacity: 1, 
      y: 0, 
      scale: 1,
      transition: { 
        delay: i * 0.1, 
        duration: 0.5, 
        ease: "easeOut" 
      } 
    }),
  };

  return (
    <div className="pt-20 overflow-hidden bg-gray-50/50 min-h-screen">
      
      {/* ==================== HERO SECTION ==================== */}
      {/* HERO SECTION - Usa Motion para la aparición inicial */}
      <motion.section 
        className="relative min-h-[calc(100vh-80px)] flex items-center bg-gradient-to-br from-[#FFF6B0]/40 via-[#FFF176]/50 to-white/70"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        
        {/* Background Parallax Effects (Sin cambios, ya usan scrollY) */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-80">
          <div 
            className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-to-br from-[#FFE55C]/40 via-[#fee017]/30 to-transparent rounded-full blur-3xl transform transition-transform duration-1000 ease-out"
            style={{ transform: `translateY(${scrollY * 0.25}px) translateX(${scrollY * 0.05}px)` }}
          />
          <div 
            className="absolute bottom-0 left-0 w-[700px] h-[700px] bg-gradient-to-tr from-[#FFF9C3]/50 via-[#FFE55C]/40 to-transparent rounded-full blur-3xl transform transition-transform duration-1000 ease-out"
            style={{ transform: `translateY(${-scrollY * 0.15}px) translateX(${-scrollY * 0.03}px)` }}
          />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 z-10">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            
            {/* Contenido Principal (con Parallax suave) */}
            <div className="space-y-8 lg:pr-8" style={{ transform: `translateY(${scrollY * -0.05}px)` }}>
              {/* Contenido aquí... (mantener sin motion directo para evitar conflictos con el parallax de scrollY) */}
              
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-amber-100 to-yellow-200 border border-amber-300 shadow-xl shadow-amber-300/30">
                <Icon.Sparkles className="w-4 h-4 text-amber-700" />
                <span className="text-sm font-bold text-amber-800 tracking-wide">Consultoría Académica Premium</span>
              </div>

              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight text-gray-900 leading-[1.05]">
                Tu tesis,
                <br />
                <span className="relative inline-block mt-2">
                  <span className="relative z-10 bg-gradient-to-r from-amber-600 via-amber-500 to-yellow-600 bg-clip-text text-transparent">
                    impecable
                  </span>
                  <span className="absolute inset-x-0 bottom-0 h-4 bg-gradient-to-r from-amber-400 to-yellow-400 rounded-lg blur-sm opacity-60"></span>
                </span>
                {' '}y a tiempo.
              </h1>

              <p className="text-xl text-gray-700 leading-relaxed max-w-xl font-medium">
                Metodología sólida, redacción profesional, análisis estadístico riguroso. 
                <span className="font-extrabold text-amber-700"> Trabajamos por hitos claros</span> y cumplimos plazos.
              </p>

              {/* CTAs */}
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <a 
                  href="#contacto"
                  className="group inline-flex items-center justify-center gap-2 px-8 py-4 text-base font-bold text-white bg-gray-900 rounded-xl hover:bg-gray-800 transition-all shadow-xl hover:shadow-2xl hover:scale-[1.02] active:scale-[0.98] focus:outline-none focus:ring-4 focus:ring-gray-300"
                >
                  Comenzar proyecto
                  <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </a>
                
                <a 
                  href={whatsappUrl}
                  target="_blank" 
                  rel="noreferrer"
                  className="group inline-flex items-center justify-center gap-2 px-8 py-4 text-base font-bold text-white bg-gradient-to-r from-green-600 to-green-500 rounded-xl hover:from-green-700 hover:to-green-600 transition-all shadow-xl hover:shadow-green-500/50 hover:scale-[1.02] active:scale-[0.98] focus:outline-none focus:ring-4 focus:ring-green-300"
                >
                  <Icon.Whatsapp />
                  WhatsApp
                </a>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-8 pt-8 border-t-2 border-amber-200/50">
                {[
                  { value: '200+', label: 'Tesis entregadas' },
                  { value: '4.9/5', label: 'Satisfacción' },
                  { value: '<4h', label: 'Respuesta' }
                ].map((stat, i) => (
                  <div key={i} className="text-left">
                    <div className="text-3xl sm:text-4xl font-extrabold bg-gradient-to-r from-amber-600 to-yellow-500 bg-clip-text text-transparent">
                      {stat.value}
                    </div>
                    <div className="text-sm text-gray-500 mt-1 font-medium">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Imagen (con Parallax suave) */}
            <div className="relative lg:order-last" style={{ transform: `translateY(${scrollY * 0.08}px)` }}>
              <div className="relative z-10 p-4 bg-white/50 backdrop-blur-sm rounded-3xl shadow-2xl">
                <img
                  src={img2}
                  alt="Tesis 1 Consultoria - Logro Académico"
                  className="w-full max-w-none lg:max-w-3xl xl:max-w-4xl mx-auto rounded-2xl transform hover:scale-[1.01] transition-transform duration-500"
                  loading="eager"
                  style={{ 
                    boxShadow: '0 40px 60px rgba(0, 0, 0, 0.1)',
                  }}
                />
              </div>
              
              {/* Decorative elements */}
              <div className="absolute top-10 -left-4 w-32 h-32 bg-gradient-to-br from-amber-400/50 to-yellow-300/40 rounded-3xl blur-3xl opacity-60 animate-pulse"></div>
              <div className="absolute bottom-10 -right-4 w-40 h-40 bg-gradient-to-br from-yellow-500/50 to-amber-500/40 rounded-full blur-3xl opacity-60 animate-pulse" style={{ animationDelay: '1s' }}></div>
            </div>
          </div>
        </div>
      </motion.section>
      
      {/* Insert Carousel: entregas exitosas (Right after hero, before services) */}
      <section id="entregas" className="py-12 lg:py-16 bg-white border-t border-brand/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-8 bg-brand rounded-full" />
            <h2 className="text-3xl font-black text-gray-900">Entregas exitosas</h2>
          </div>
          <p className="text-gray-600 mb-6">Ejemplos de trabajos entregados por nuestro equipo.</p>
          <Carousel />
        </div>
      </section>

      <hr className="my-0 border-gray-100" />
      
      {/* ==================== SERVICES SECTION ==================== */}
      <section id="servicios" className="py-24 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionTitle
            kicker="Nuestros Servicios"
            title="Soluciones completas para tu éxito académico"
            subtitle="Asesoría especializada en cada etapa de tu proyecto de investigación, con enfoque en calidad y cumplimiento de normas."
            // Se anima dentro del componente SectionTitle
          />

          <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Implementamos la animación secuencial en las tarjetas */}
            {services.map((s, idx) => {
              const path = s.path ? `/servicios/${s.path}` : `/servicios/${encodeURIComponent(s.name.toLowerCase().replaceAll(' ', '-'))}`;
              return (
                <motion.div
                  key={s.name}
                  custom={idx} // Pasa el índice para el cálculo del delay
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  variants={serviceCardVariants}
                >
                  <Link
                    to={path}
                    className="group relative bg-white rounded-3xl p-8 border border-gray-100 hover:border-amber-300 hover:shadow-xl hover:shadow-amber-200/50 transition-all duration-500 transform hover:-translate-y-2 overflow-hidden focus:outline-none focus:ring-4 focus:ring-amber-200 block h-full"
                  >
                    {/* Background sutil en hover */}
                    <div className="absolute inset-0 bg-gradient-to-br from-yellow-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    
                    <div className="relative">
                      {/* Icono */}
                      <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-400 to-yellow-500 flex items-center justify-center text-white group-hover:scale-105 transition-transform duration-300 shadow-xl shadow-amber-400/40">
                        {getServiceIcon(s.name)}
                      </div>
                      
                      <h3 className="mt-6 text-2xl font-extrabold text-gray-900 group-hover:text-amber-700 transition-colors">
                        {s.name}
                      </h3>
                      
                      {/* Precio */}
                      <div className="mt-3 text-3xl font-black bg-gradient-to-r from-amber-600 to-yellow-500 bg-clip-text text-transparent">
                        {typeof s.price === 'number' ? `S/ ${s.price.toLocaleString('es-PE')}` : s.price}
                      </div>
                      
                      <p className="mt-4 text-gray-500 leading-relaxed text-sm">
                        Asesoría personalizada con entregables por hitos claros y seguimiento continuo para tu tranquilidad.
                      </p>
                      
                      <div className="mt-6 flex items-center gap-2 text-amber-600 font-bold group-hover:gap-3 transition-all">
                        Ver detalle completo
                        <Icon.Arrow className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                      </div>
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <hr className="my-0 border-gray-100" />
      
      {/* ==================== CONTACT SECTION ==================== */}
      <section id="contacto" className="py-24 lg:py-32 bg-gray-50/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionTitle
            kicker="Empieza Hoy"
            title="Cuéntanos sobre tu proyecto"
            subtitle="Respuesta garantizada en menos de 4 horas. Tu primer paso hacia el éxito académico."
          />

          <div className="mt-16 grid lg:grid-cols-2 gap-16 max-w-6xl mx-auto items-start">
            
            {/* Lista de Beneficios (Con animación de aparición lateral) */}
            <motion.div
              className="space-y-10 lg:sticky lg:top-24"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <div>
                <h3 className="text-3xl font-extrabold text-gray-900 mb-6 border-b-2 border-amber-200/50 pb-2">¿Por qué elegir Tesis 1?</h3>
                <ul className="space-y-6">
                  {[
                    'Acompañamiento personalizado y enfocado en tus plazos',
                    'Cumplimiento estricto de normas APA, ISO, Vancouver, etc.',
                    'Análisis estadístico profesional (SPSS, R, Python) y resultados confiables',
                    'Garantía antiplagio (Turnitin) incluida, con reporte de originalidad',
                    'Preparación de defensa, simulación y diseño de diapositivas'
                  ].map((item, i) => (
                    <motion.li 
                      key={i} 
                      className="flex items-start gap-3 group"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true, amount: 0.2 }}
                      transition={{ duration: 0.5, delay: 0.2 + i * 0.1 }} // Animación en cascada
                    >
                      <span className="mt-1 w-7 h-7 rounded-full bg-green-500/10 flex items-center justify-center text-green-600 flex-shrink-0 group-hover:scale-110 transition-transform shadow-md">
                        <Icon.Check className="w-4 h-4" />
                      </span>
                      <span className="text-lg text-gray-700 leading-relaxed font-medium">{item}</span>
                    </motion.li>
                  ))}
                </ul>

                <div className="mt-10">
                  <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-green-600 to-green-500 text-white font-bold rounded-xl hover:from-green-700 hover:to-green-600 transition-all shadow-xl hover:shadow-green-500/50 hover:scale-[1.02] active:scale-[0.98] focus:outline-none focus:ring-4 focus:ring-green-300"
                  >
                    <Icon.Whatsapp />
                    Chatear con un Asesor
                  </a>
                </div>
              </div>
            </motion.div>

            {/* Formulario de Contacto (Con animación de aparición lateral opuesta) */}
            <motion.div
              className="relative"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              {/* Overlay de fondo borroso */}
              <div className="absolute inset-0 bg-gradient-to-br from-amber-50/70 via-yellow-100/50 to-yellow-50/70 rounded-3xl blur-3xl"></div>
              
              <form 
                onSubmit={handleSubmit}
                className="relative bg-white rounded-3xl p-8 sm:p-12 shadow-2xl border-4 border-amber-200/50 space-y-7 transform transition-all duration-300 hover:shadow-amber-300/40"
              >
                {/* Campos del formulario... (sin cambios) */}
                <h4 className="text-2xl font-extrabold text-gray-900">Formulario de Contacto</h4>
                
                <div>
                  <label htmlFor="name" className="block text-sm font-bold text-gray-900 mb-2">Nombre completo</label>
                  <input
                    id="name"
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    className="w-full px-5 py-3 rounded-xl border-2 border-gray-200 focus:border-amber-500 focus:ring-4 focus:ring-amber-100/50 transition-colors text-gray-900 placeholder-gray-500"
                    placeholder="Tu nombre completo"
                    required
                  />
                </div>

                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="email" className="block text-sm font-bold text-gray-900 mb-2">Correo electrónico</label>
                    <input
                      id="email"
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      className="w-full px-5 py-3 rounded-xl border-2 border-gray-200 focus:border-amber-500 focus:ring-4 focus:ring-amber-100/50 transition-colors text-gray-900 placeholder-gray-500"
                      placeholder="tu@correo.com"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="deadline" className="block text-sm font-bold text-gray-900 mb-2">Fecha límite (opcional)</label>
                    <input
                      id="deadline"
                      type="date"
                      onChange={(e) => setFormData({...formData, deadline: e.target.value})}
                      className="w-full px-5 py-3 rounded-xl border-2 border-gray-200 focus:border-amber-500 focus:ring-4 focus:ring-amber-100/50 transition-colors text-gray-900 placeholder-gray-500"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-bold text-gray-900 mb-2">Detalles del proyecto</label>
                  <textarea
                    id="message"
                    rows={5}
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    className="w-full px-5 py-3 rounded-xl border-2 border-gray-200 focus:border-amber-500 focus:ring-4 focus:ring-amber-100/50 transition-colors resize-none text-gray-900 placeholder-gray-500"
                    placeholder="Carrera, tema de investigación, entregables, fecha límite..."
                    required
                  />
                </div>
                
                {/* Botón de Envío */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full py-4 text-base font-extrabold text-gray-900 bg-gradient-to-r from-amber-400 to-yellow-500 rounded-xl hover:from-yellow-500 hover:to-amber-400 transition-all shadow-xl hover:shadow-amber-500/50 disabled:opacity-60 disabled:cursor-not-allowed transform hover:scale-[1.01] active:scale-[0.99] focus:outline-none focus:ring-4 focus:ring-amber-300/70"
                >
                  {isSubmitting ? (
                    <span className="flex items-center justify-center gap-2">
                      <svg className="animate-spin h-5 w-5 text-gray-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Enviando...
                    </span>
                  ) : (
                    'Enviar consulta'
                  )}
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}